import axios, { AxiosInstance } from 'axios'
import { IUserData } from '../types/services-types/user-types'

const baseURL = 'https://fin-rassvet.su/api'

const api = axios.create({
  baseURL,
  withCredentials: true
})

export function attachAuthInterceptors(instance: AxiosInstance) {
 
  instance.interceptors.request.use(config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })

 
  instance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config

      if (error.config?.url === '/user/refresh') {
        throw error
      }

      if (error.response?.status === 401 && !originalRequest._isRetry) {
        originalRequest._isRetry = true
        try {
          const refreshResponse = await api.get<IUserData>('/user/refresh')
          localStorage.setItem('accessToken', refreshResponse.data.tokens.access_token)

          
          return instance.request(originalRequest)
        } catch (refreshError) {
          throw refreshError
        }
      }

      throw error
    }
  )
}

export function createApiService(path: string): AxiosInstance {
  const instance = axios.create({
    baseURL: baseURL + path,
    withCredentials: true
  })
  attachAuthInterceptors(instance)
  return instance
}

export default api